var map = {
	"./template.betgalaxy": 1984,
	"./template.betgalaxy.tsx": 1984,
	"./template.betroyale": 1985,
	"./template.betroyale.tsx": 1985,
	"./template.default": 649,
	"./template.default.tsx": 649,
	"./template.fiestabet": 1986,
	"./template.fiestabet.tsx": 1986,
	"./template.puntcity": 1987,
	"./template.puntcity.tsx": 1987,
	"./template.questbet": 1988,
	"./template.questbet.tsx": 1988,
	"./template.ts": 726,
	"./template.volcanobet": 1989,
	"./template.volcanobet.tsx": 1989,
	"./template.wellbet": 1990,
	"./template.wellbet.tsx": 1990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2283;